import InputView from "./input_view";
import { default as template } from "./button/template.jst";

import $ from "jquery";

class Button extends InputView {
  events() {
    return {
      "click": this.options.click || $.noop
    };
  }

  lock(value) {
    this.$el.prop("disabled", value);
  }

  beforeRender() {
    const content = template({
      icon: this.options.icon,
      statusIcon: this.options.statusIcon,
      text: this.options.text
    });

    if (this.tagName === 'button') {
      this.$el.attr("type", "button").addClass("btn");
    }

    this.$el.html(content);
  }

  afterRender() {
    if (this.options.helpPopover) {
      this.$el.helpPopover(this.options.helpPopover);
    }
  }
}

Button.prototype.tagName = "button";

export default Button;
